import { ItemType, MenuItemType } from 'antd/es/menu/interface'
import MainContentLayout from '../../components/MainContentLayout'
import { PlaylistsRouter, TracksRouter } from '../../utils/routes/MusicRoutes'
import { ClientsRouter, OrdersRouter } from '../../utils/routes/UsersRoutes'

const menu: ItemType<MenuItemType>[] = [
  {
    label: 'All',
    key: 'all',
  },
  {
    label: 'New',
    key: 'new',
  },
]

export default function Orders() {
  return (
    <MainContentLayout
      navigationHeader={{
        headerMenu: menu,
        navigationPrefix: '/orders/',
      }}
    >
      <OrdersRouter />
    </MainContentLayout>
  )
}
